import { useDebounce } from '../useDebounce';
import type { ModifiedEvent, SurveyCreatorModel } from 'survey-creator-core';
import { useUpdateForm } from 'hooks/Forms';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

export const useUpdateSurveyForm = (formID: string | null | undefined) => {
  const queryClient = useQueryClient();
  const debounce = useDebounce();
  const { mutateAsync: updateForm } = useUpdateForm(formID);
  const { id: sparkID = null } = useParams();

  const handleFormUpdate = async (
    sender: SurveyCreatorModel,
    options: ModifiedEvent
  ) => {
    const debounced = debounce<typeof updateForm>(updateForm, 2000);
    await debounced({ config: sender.text });
    if (
      options.type === 'OBJECT_DELETED' ||
      options.type === 'PROPERTY_CHANGED'
    ) {
      queryClient.invalidateQueries(['sparkOutputReferences', sparkID]);
    }
  };
  return { handleFormUpdate };
};
